import {boolean, Decoder, field, nullable, number, object} from 'json-bouncer'
import * as PrismaRequestOfferType from './PrismaRequestOfferType'
import * as PrismaRequestOfferStatus from './PrismaRequestOfferStatus'

export interface M {
    readonly id: number
    readonly prismaRequestId: number
    readonly manufacturerId: number
    readonly netPrice: number | null
    readonly selected: boolean
    readonly type: PrismaRequestOfferType.M
    readonly status: PrismaRequestOfferStatus.M
}

export function decoder(): Decoder<M> {
    return object({
        id: field('id', number()),
        prismaRequestId: field('prismaRequestId', number()),
        manufacturerId: field('manufacturerId', number()),
        netPrice: field('netPrice', nullable(number())),
        selected: field('selected', boolean()),
        type: field('type', PrismaRequestOfferType.decoder()),
        status: field('status', PrismaRequestOfferStatus.decoder())
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/PrismaRequestOffer.ts